import 'antd/dist/antd.css';
// import axios from 'axios';
import axios from '../../utils/request';
import React, { Component } from "react";
import { Spinner } from 'reactstrap';

export class Starbucks_TransferToCancel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            commonParamater: null,
            tips: { code: "", message: "" },
        }
        this.reactQuillRef = null;
        this.modules = null;
        this.formRef = React.createRef();
        this.tt = React.create
    };

    componentDidMount() {

        //this.setState({ isReady: true, tips: { code: "200", message: "操作成功" } });
        //this.closeMobilePage();
        //return;

        document.title = '星巴克-取消录用'

        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        if (!commonParamater) {
            this.setState({ tips: { code: "400", message: "commonParamater参数不存在！" }, isReady: true });
            return;
        }

        this.cancelEmploy(commonParamater);
    };

    cancelEmploy = (commonParamater) => {
        axios.get("/api/stb/application/commonparameters/analysis?commonParamater=" + commonParamater)
            .then(res => {
                debugger;
                if (res?.data?.code == "200") {
                    axios.put("/api/stb/application/TransferToCancelState", JSON.stringify({ applyId: res?.data?.data?.applyIds }), {
                        headers: { "Content-Type": "application/json" }
                    })
                        .then(cancelEmployRes => {
                            this.setState({ isReady: true, tips: cancelEmployRes?.data });
                            this.closeMobilePage();
                        })
                        .catch(reason => {
                            console.log(reason);
                            this.setState({ isReady: true, tips: { code: "500", message: "网络繁忙，请稍后再试" } });
                        })
                }
                else {
                    this.setState({ isReady: true, tips: res?.data })
                }
            }).catch(reason => {
                console.log(reason);
                this.setState({ isReady: true, tips: { code: "500", message: "网络繁忙，请稍后再试！" } });
            })
    }

    closeMobilePage = () => {
        setTimeout(function () {
            window.history.back();
        }, 3000);
    }

    render() {
        if (this.state.isReady) {
            if (this.state?.tips?.code === "200") {
                return (<div style={{ textAlign: "center", padding: "100px", fontSize: "18px" }}>
                    <div style={{ color: "green" }}>{this.state?.tips?.message}</div>
                </div>);
            }
            else {
                return (<div style={{ textAlign: "center", padding: "100px", fontSize: "18px" }}><span style={{ color: "red" }}>{this.state?.tips?.message}</span></div>);
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}